import {Action} from '@ngrx/store';
import {IQMTimePeriod} from '@app/modules/home/modules/payment/components/new-salary-export/components/select-period/select-period.component';
import {IQOSelectData} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-select-data';
import {Department} from '@app/core/models/department.model';
import {Group} from '@app/core/models/group.model';
import {User} from '@app/core/models/user.model';
import {QMIntegration} from '@app/core/models/QMIntegration.model';
import {IQMNewSalaryExportData, IQMShiftCountData} from '@app/core/services/api/payroll.service';
import {ICalculation, ICalculations} from '@app/core/interfaces/salary';
import {IShiftCount} from '@app/core/interfaces/shiftCount';

export interface IQMDepartmentWithUsers {
	department: {
		department?: Department,
		id: number,
		users: {
			user?: User,
			id: number,
		}[],
	};
}

export enum ENewSalaryExportActions {
	GetDepartments = '[NewSalaryExport] Get Departments',
	GetDepartmentsSuccess = '[NewSalaryExport] Get Departments Success',

	GetGroups = '[NewSalaryExport] Get Groups',
	GetGroupsSuccess = '[NewSalaryExport] Get Groups Success',

	SetSelectedDepartment = '[NewSalaryExport] Set Selected Department',

	SetSelectedUsers = '[NewSalaryExport] Set Selected Users',
	AddUserToSelectedUsers = '[NewSalaryExport] Add User To Selected Users',
	RemoveUserFromSelectedUsers = '[NewSalaryExport] Remove User From Selected Users',

	SetSelectedTimePeriod = '[NewSalaryExport] Set Selected Time Period',

	AddDepartmentWithUsers = '[NewSalaryExport] Add Department With Users',
	RemoveDepartmentWithUsers = '[NewSalaryExport] Remove Department With Users',

	RemoveDepartment = '[NewSalaryExport] Remove Department',
	AddDepartment = '[NewSalaryExport] Add Department',

	GetIntegrations = '[NewSalaryExport] Get Integrations',
	GetIntegrationsSuccess = '[NewSalaryExport] Get Integrations Success',

	SetSelectedIntegration = '[NewSalaryExport] Set Selected Integration',

	AddIntegration = '[NewSalaryExport] Add Integration',
	RemoveIntegration = '[NewSalaryExport] Remove Integration',

	FinishExport = '[NewSalaryExport] Finish Export',
	FinishExportSuccess = '[NewSalaryExport] Finish Export Success',

	GetShiftCount = '[NewSalaryExport] Get shift count',
	GetShiftCountSuccess = '[NewSalaryExport] Get shift count Success',

	GetShiftCalculations = '[NewSalaryExport] Get shift calculations',
	GetShiftCalculationsSuccess = '[NewSalaryExport] Get shift calculations Success',

	GetShiftCalculation = '[NewSalaryExport] Get shift calculation',
	GetShiftCalculationSuccess = '[NewSalaryExport] Get shift calculation Success',

	SetSelectedYear = '[NewSalaryExport] Set Selected Year',
	SetSelectedMonth = '[NewSalaryExport] Set Selected Month',

}

export class FinishExport implements Action {
	public readonly type = ENewSalaryExportActions.FinishExport;

	constructor(
		public data: IQMNewSalaryExportData,
	) {
	}
}

export class FinishExportSuccess implements Action {
	public readonly type = ENewSalaryExportActions.FinishExportSuccess;

	constructor() {
	}
}

export class SetSelectedIntegration implements Action {
	public readonly type = ENewSalaryExportActions.SetSelectedIntegration;

	constructor(public integration: IQOSelectData<QMIntegration>) {
	}
}

export class GetShiftCount implements Action {
	public readonly type = ENewSalaryExportActions.GetShiftCount;

	constructor(public data: IQMShiftCountData) {
	}
}

export class GetShiftCountSuccess implements Action {
	public readonly type = ENewSalaryExportActions.GetShiftCountSuccess;

	constructor(public shiftCount: IShiftCount) {
	}
}

export class AddIntegration implements Action {
	public readonly type = ENewSalaryExportActions.AddIntegration;

	constructor(public integration: QMIntegration) {
	}
}

export class RemoveIntegration implements Action {
	public readonly type = ENewSalaryExportActions.RemoveIntegration;

	constructor(public integration: QMIntegration) {
	}
}

export class GetIntegrations implements Action {
	public readonly type = ENewSalaryExportActions.GetIntegrations;

	constructor() {
	}
}

export class GetIntegrationsSuccess implements Action {
	public readonly type = ENewSalaryExportActions.GetIntegrationsSuccess;

	constructor(public integrations: QMIntegration[]) {
	}
}

export class RemoveDepartment implements Action {
	public readonly type = ENewSalaryExportActions.RemoveDepartment;

	constructor(public department: Department) {
	}
}

export class AddDepartment implements Action {
	public readonly type = ENewSalaryExportActions.AddDepartment;

	constructor(public department: Department) {
	}
}

export class AddDepartmentWithUsers implements Action {
	public readonly type = ENewSalaryExportActions.AddDepartmentWithUsers;

	constructor(public departmentWithUsers: IQMDepartmentWithUsers) {
	}
}

export class RemoveDepartmentWithUsers implements Action {
	public readonly type = ENewSalaryExportActions.RemoveDepartmentWithUsers;

	constructor(public departmentWithUsers: IQMDepartmentWithUsers) {
	}
}

export class SetSelectedDepartment implements Action {
	public readonly type = ENewSalaryExportActions.SetSelectedDepartment;

	constructor(public department: IQOSelectData<Department>) {
	}
}

export class AddUserToSelectedUsers implements Action {
	public readonly type = ENewSalaryExportActions.AddUserToSelectedUsers;

	constructor(public user: IQOSelectData<User>) {
	}
}

export class RemoveUserFromSelectedUsers implements Action {
	public readonly type = ENewSalaryExportActions.RemoveUserFromSelectedUsers;

	constructor(public user: IQOSelectData<User>) {
	}
}

export class SetSelectedUsers implements Action {
	public readonly type = ENewSalaryExportActions.SetSelectedUsers;

	constructor(public users: IQOSelectData<User>[]) {
	}
}

export class GetDepartments implements Action {
	public readonly type = ENewSalaryExportActions.GetDepartments;

	constructor() {
	}
}

export class GetDepartmentsSuccess implements Action {
	public readonly type = ENewSalaryExportActions.GetDepartmentsSuccess;

	constructor(public departments: Department[]) {
	}
}

export class GetGroups implements Action {
	public readonly type = ENewSalaryExportActions.GetGroups;

	constructor(public department: Department) {
	}
}

export class GetGroupsSuccess implements Action {
	public readonly type = ENewSalaryExportActions.GetGroupsSuccess;

	constructor(public groups: Group[]) {
	}
}

export class GetShiftCalculations implements Action {
	public readonly type = ENewSalaryExportActions.GetShiftCalculations;

	constructor(public year: number, public month: number, public department_id: number) {
	}
}

export class GetShiftCalculationsSuccess implements Action {
	public readonly type = ENewSalaryExportActions.GetShiftCalculationsSuccess;

	constructor(public calculations: ICalculations) {
	}
}

export class GetShiftCalculation implements Action {
	public readonly type = ENewSalaryExportActions.GetShiftCalculation;

	constructor(public year: number, public month: number, public department_id: number, public user_id: number) {
	}
}

export class GetShiftCalculationSuccess implements Action {
	public readonly type = ENewSalaryExportActions.GetShiftCalculationSuccess;

	constructor(public calculation: ICalculation) {
	}
}

export class SetSelectedTimePeriod implements Action {
	public readonly type = ENewSalaryExportActions.SetSelectedTimePeriod;

	constructor(public timePeriod: IQMTimePeriod) {
	}
}

export class SetSelectedYear implements Action {
	public readonly type = ENewSalaryExportActions.SetSelectedYear;

	constructor(public year: number) {
	}
}

export class SetSelectedMonth implements Action {
	public readonly type = ENewSalaryExportActions.SetSelectedMonth;

	constructor(public month: number) {
	}
}

export type NewSalaryExportActions =
	GetDepartments |
	GetDepartmentsSuccess |
	SetSelectedTimePeriod |
	GetGroups |
	GetGroupsSuccess |
	SetSelectedDepartment |
	SetSelectedUsers |
	AddUserToSelectedUsers |
	RemoveUserFromSelectedUsers |
	AddDepartmentWithUsers |
	RemoveDepartmentWithUsers |
	RemoveDepartment |
	AddDepartment |
	SetSelectedIntegration |
	AddIntegration |
	RemoveIntegration |
	GetIntegrations |
	GetIntegrationsSuccess |
	FinishExport |
	FinishExportSuccess |
	GetShiftCount |
	GetShiftCountSuccess |
	GetShiftCalculations |
	GetShiftCalculationsSuccess |
	GetShiftCalculation |
	GetShiftCalculationSuccess |
	SetSelectedYear |
	SetSelectedMonth
	;

